import type { SchoolGoal } from '@whizz/api-model';
import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { ButtonIcon } from '../../../../components';

const AdminGoalCard = ({ goal, onEdit }: { goal: SchoolGoal, onEdit: () => void }): JSX.Element => {
  const { translate: t } = useI18n();
  return (
    <div className={'flex flex-col gap-2 p-4 bg-white rounded-lg shadow'}>
      <div className={'flex justify-between items-center'}>
        <h3 className={'text-lg font-semibold'}>{t(`pages.ADMIN.IMPACT_REPORTS.GOALS.${goal.goal_key}`)}</h3>
        <ButtonIcon
          type={'button'}
          icon={'Edit'}
          asLink
          size={'sm'}
          onClick={onEdit}
        />
      </div>
      {goal.metrics.length > 0 && (
        <ol className={'mt-2 pl-5 space-y-2 list-disc'}>
          {goal.metrics.map((metric, index) => (
            <li key={index}>{t(`pages.ADMIN.IMPACT_REPORTS.METRICS.${metric}`)}</li>
          ))}
        </ol>
      )}
    </div>
  );
};

export { AdminGoalCard };
